/**
 * Trade Onboarding Modal — multi-slide welcome flow for new
 * trade customers.
 *
 * Loaded by sections/trade-onboarding-modal.liquid.
 * Auto-shows for customers tagged pre-approved-trade or
 * approved-trade who haven't completed onboarding.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const sectionElement = document.querySelector('.trade-onboarding');
    if (!sectionElement) return;

    const isCustomer = sectionElement.dataset.isCustomer === 'true';
    const customerTags = sectionElement.dataset.customerTags || '';
    const customerTagList = customerTags
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
    const modal = document.getElementById('trade-onboarding-modal');

    // Check if customer should see onboarding
    const shouldShowOnboarding =
      isCustomer &&
      (
        customerTagList.includes('pre-approved-trade') ||
        customerTagList.includes('approved-trade')
      ) &&
      !customerTagList.includes('trade-onboarding-complete');

    if (!shouldShowOnboarding) return; // Don't show modal if conditions aren't met

    // Show modal automatically (use shared modal overlay behavior)
    setTimeout(() => {
      modal.style.display = 'flex';
    }, 500); // Small delay for better UX

    const slides = document.querySelectorAll('.onboarding-slide');
    const continueButtons = modal.querySelectorAll('.Button');

    let currentSlide = 0;
    const slideCount = slides.length;

    function updateSlide() {
      slides.forEach((slide, index) => {
        if (index === currentSlide) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });
    }

    function closeModal() {
      modal.style.display = 'none';
    }

    function setOnboardingCompleteTag() {
      const customerId = sectionElement.dataset.customerId;
      tradeFetch(`${window.tradeApiBase}/users/onboarding-complete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      }, { source: 'TradeOnboarding.complete' })
        .then((response) => {
          closeModal();
        })
        .catch((error) => {
          console.error('Failed to update onboarding status:', error);
          closeModal(); // Close modal even if API call fails
        });
    }

    // Continue button functionality
    continueButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const slideNumber = parseInt(this.dataset.slideNumber);
        const totalSlides = parseInt(this.dataset.totalSlides);

        if (slideNumber < totalSlides) {
          currentSlide++;
          updateSlide();
        } else {
          // Last slide - complete onboarding
          setOnboardingCompleteTag();
        }
      });
    });

    // Initialize the first slide
    updateSlide();
  });
})();
